import React from 'react';
import { CourseTopBarLinks } from '../Styles/Course';
import { ILinks } from '../../../__core/Interfaces/ILinks';
import { useTranslation } from 'react-i18next';
import {
  calendarIcon,
  jiraIcon,
  testlinkIcon,
  recordsIcon,
  screenIcon,
  trelloIcon,
  chatIcon,
} from '../../../Assets/images/Icons';
import PortalProvider from '../../../__core/Providers/Portal/PortalProvider';
import { CourseLinks } from '../../App/Styles/MobileMenu';
import MediaQuery from 'react-responsive';
import { defaultTheme } from '../../../__core/Themes/Default';
import AppConfig from '../../../Configs/AppConfig';

type LinksProps = {
  links: ILinks;
};

const Links: React.FunctionComponent<LinksProps> = ({
  links,
}): React.ReactElement => {
  const { t } = useTranslation();

  const linksElement = (
    <>
      {links.classroom && (
        <a href={links.classroom} target="_blank" rel="noopener noreferrer">
          {screenIcon} <span>{t('Virtual Classroom')}</span>
        </a>
      )}
      {links.trello && (
        <a href={links.trello} target="_blank" rel="noopener noreferrer">
          {trelloIcon} <span>{t('Trello')}</span>
        </a>
      )}
      {links.chat && (
        <a href={links.chat} target="_blank" rel="noopener noreferrer">
          {chatIcon} <span>{t('Chat')}</span>
        </a>
      )}
      {links.schedule && (
        <a
          href={`${AppConfig.HUB_URL}${links.schedule}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {calendarIcon} <span>{t('Course schedule')}</span>
        </a>
      )}
      {links.records && (
        <a href={links.records} target="_blank" rel="noopener noreferrer">
          {recordsIcon} <span>{t('Records')}</span>
        </a>
      )}
      {links.jira && (
        <a href={links.jira} target="_blank" rel="noopener noreferrer">
          {jiraIcon} <span>{t('Jira')}</span>
        </a>
      )}
      {links.testlink && (
        <a href={links.testlink} target="_blank" rel="noopener noreferrer">
          {testlinkIcon} <span>{t('Testlink')}</span>
        </a>
      )}
    </>
  );

  return (
    <>
      <CourseTopBarLinks>{linksElement}</CourseTopBarLinks>
      <MediaQuery maxDeviceWidth={defaultTheme.SCREEN_SIZES.tablet}>
        <PortalProvider nodeId="course-data-portal">
          <CourseLinks>{linksElement}</CourseLinks>
        </PortalProvider>
      </MediaQuery>
    </>
  );
};

export default Links;
